<template>
<svg version="1.1" id="A-04" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 viewBox="0 0 144 220" enable-background="new 0 0 144 220" xml:space="preserve">
<pattern  y="220" width="12.0001" height="21.642" patternUnits="userSpaceOnUse" id="SVGID_A-04_1_" viewBox="0.9999 -27.302 12.0001 21.642" overflow="visible">
	<g>
		<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
		<g>
			<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
			<rect x="1" y="-27.302" fill="none" width="12" height="21.6418"/>
			<polygon fill="#363435" points="13,0 14,-0.999 14,-10.321 13,-11.321 12,-10.321 12,-0.999 			"/>
			<polygon fill="#363435" points="10.6,0 11.6,-0.999 11.6,-10.321 10.6,-11.321 9.6,-10.321 9.6,-0.999 			"/>
			<polygon fill="#363435" points="8.2,0 9.2,-0.999 9.2,-10.321 8.2,-11.321 7.2,-10.321 7.2,-0.999 			"/>
			<polygon fill="#363435" points="5.8,0 6.8,-0.999 6.8,-10.321 5.8,-11.321 4.8,-10.321 4.8,-0.999 			"/>
			<polygon fill="#363435" points="3.4,0 4.4,-0.999 4.4,-10.321 3.4,-11.321 2.4,-10.321 2.4,-0.999 			"/>
			<polygon fill="#363435" points="1,0 2,-0.999 2,-10.321 1,-11.321 0,-10.321 0,-0.999 			"/>
			<polygon fill="#363435" points="11.8,-10.821 12.8,-11.82 12.8,-21.142 11.8,-22.141 10.8,-21.142 10.8,-11.82 			"/>
			<polygon fill="#363435" points="9.4,-10.821 10.4,-11.82 10.4,-21.142 9.4,-22.141 8.4,-21.142 8.4,-11.82 			"/>
			<polygon fill="#363435" points="7,-10.821 8,-11.82 8,-21.142 7,-22.141 6,-21.142 6,-11.82 			"/>
			<polygon fill="#363435" points="4.6,-10.821 5.6,-11.82 5.6,-21.142 4.6,-22.141 3.6,-21.142 3.6,-11.82 			"/>
			<polygon fill="#363435" points="2.2,-10.821 3.2,-11.82 3.2,-21.142 2.2,-22.141 1.2,-21.142 1.2,-11.82 			"/>
			<polygon fill="#363435" points="13,-21.641 14,-22.64 14,-31.963 13,-32.962 12,-31.963 12,-22.64 			"/>
			<polygon fill="#363435" points="10.6,-21.641 11.6,-22.64 11.6,-31.963 10.6,-32.962 9.6,-31.963 9.6,-22.64 			"/>
			<polygon fill="#363435" points="8.2,-21.641 9.2,-22.64 9.2,-31.963 8.2,-32.962 7.2,-31.963 7.2,-22.64 			"/>
			<polygon fill="#363435" points="5.8,-21.641 6.8,-22.64 6.8,-31.963 5.8,-32.962 4.8,-31.963 4.8,-22.64 			"/>
			<polygon fill="#363435" points="3.4,-21.641 4.4,-22.64 4.4,-31.963 3.4,-32.962 2.4,-31.963 2.4,-22.64 			"/>
			<polygon fill="#363435" points="1,-21.641 2,-22.64 2,-31.963 1,-32.962 0,-31.963 0,-22.64 			"/>
		</g>
	</g>
</pattern>
<pattern  y="220" width="12.0001" height="21.642" patternUnits="userSpaceOnUse" id="SVGID_A-04_2_" viewBox="0.9999 -27.302 12.0001 21.642" overflow="visible">
	<g>
		<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
		<g>
			<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
			<rect x="1" y="-27.302" fill="none" width="12" height="21.6418"/>
			<polygon fill="#414142" points="13,0 14,-0.999 14,-10.321 13,-11.321 12,-10.321 12,-0.999 			"/>
			<polygon fill="#414142" points="10.6,0 11.6,-0.999 11.6,-10.321 10.6,-11.321 9.6,-10.321 9.6,-0.999 			"/>
			<polygon fill="#414142" points="8.2,0 9.2,-0.999 9.2,-10.321 8.2,-11.321 7.2,-10.321 7.2,-0.999 			"/>
			<polygon fill="#414142" points="5.8,0 6.8,-0.999 6.8,-10.321 5.8,-11.321 4.8,-10.321 4.8,-0.999 			"/>
			<polygon fill="#414142" points="3.4,0 4.4,-0.999 4.4,-10.321 3.4,-11.321 2.4,-10.321 2.4,-0.999 			"/>
			<polygon fill="#414142" points="1,0 2,-0.999 2,-10.321 1,-11.321 0,-10.321 0,-0.999 			"/>
			<polygon fill="#414142" points="11.8,-10.821 12.8,-11.82 12.8,-21.142 11.8,-22.141 10.8,-21.142 10.8,-11.82 			"/>
			<polygon fill="#414142" points="9.4,-10.821 10.4,-11.82 10.4,-21.142 9.4,-22.141 8.4,-21.142 8.4,-11.82 			"/>
			<polygon fill="#414142" points="7,-10.821 8,-11.82 8,-21.142 7,-22.141 6,-21.142 6,-11.82 			"/>
			<polygon fill="#414142" points="4.6,-10.821 5.6,-11.82 5.6,-21.142 4.6,-22.141 3.6,-21.142 3.6,-11.82 			"/>
			<polygon fill="#414142" points="2.2,-10.821 3.2,-11.82 3.2,-21.142 2.2,-22.141 1.2,-21.142 1.2,-11.82 			"/>
			<polygon fill="#414142" points="13,-21.641 14,-22.64 14,-31.963 13,-32.962 12,-31.963 12,-22.64 			"/>
			<polygon fill="#414142" points="10.6,-21.641 11.6,-22.64 11.6,-31.963 10.6,-32.962 9.6,-31.963 9.6,-22.64 			"/>
			<polygon fill="#414142" points="8.2,-21.641 9.2,-22.64 9.2,-31.963 8.2,-32.962 7.2,-31.963 7.2,-22.64 			"/>
			<polygon fill="#414142" points="5.8,-21.641 6.8,-22.64 6.8,-31.963 5.8,-32.962 4.8,-31.963 4.8,-22.64 			"/>
			<polygon fill="#414142" points="3.4,-21.641 4.4,-22.64 4.4,-31.963 3.4,-32.962 2.4,-31.963 2.4,-22.64 			"/>
			<polygon fill="#414142" points="1,-21.641 2,-22.64 2,-31.963 1,-32.962 0,-31.963 0,-22.64 			"/>
		</g>
	</g>
</pattern>
<pattern  y="220" width="12.0001" height="21.642" patternUnits="userSpaceOnUse" id="SVGID_A-04_3_" viewBox="0.9999 -27.302 12.0001 21.642" overflow="visible">
	<g>
		<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
		<g>
			<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
			<rect x="1" y="-27.302" fill="none" width="12" height="21.6418"/>
			<polygon fill="#414142" points="13,0 14,-0.999 14,-10.321 13,-11.321 12,-10.321 12,-0.999 			"/>
			<polygon fill="#414142" points="10.6,0 11.6,-0.999 11.6,-10.321 10.6,-11.321 9.6,-10.321 9.6,-0.999 			"/>
			<polygon fill="#414142" points="8.2,0 9.2,-0.999 9.2,-10.321 8.2,-11.321 7.2,-10.321 7.2,-0.999 			"/>
			<polygon fill="#414142" points="5.8,0 6.8,-0.999 6.8,-10.321 5.8,-11.321 4.8,-10.321 4.8,-0.999 			"/>
			<polygon fill="#414142" points="3.4,0 4.4,-0.999 4.4,-10.321 3.4,-11.321 2.4,-10.321 2.4,-0.999 			"/>
			<polygon fill="#414142" points="1,0 2,-0.999 2,-10.321 1,-11.321 0,-10.321 0,-0.999 			"/>
			<polygon fill="#414142" points="11.8,-10.821 12.8,-11.82 12.8,-21.142 11.8,-22.141 10.8,-21.142 10.8,-11.82 			"/>
			<polygon fill="#414142" points="9.4,-10.821 10.4,-11.82 10.4,-21.142 9.4,-22.141 8.4,-21.142 8.4,-11.82 			"/>
			<polygon fill="#414142" points="7,-10.821 8,-11.82 8,-21.142 7,-22.141 6,-21.142 6,-11.82 			"/>
			<polygon fill="#414142" points="4.6,-10.821 5.6,-11.82 5.6,-21.142 4.6,-22.141 3.6,-21.142 3.6,-11.82 			"/>
			<polygon fill="#414142" points="2.2,-10.821 3.2,-11.82 3.2,-21.142 2.2,-22.141 1.2,-21.142 1.2,-11.82 			"/>
			<polygon fill="#414142" points="13,-21.641 14,-22.64 14,-31.963 13,-32.962 12,-31.963 12,-22.64 			"/>
			<polygon fill="#414142" points="10.6,-21.641 11.6,-22.64 11.6,-31.963 10.6,-32.962 9.6,-31.963 9.6,-22.64 			"/>
			<polygon fill="#414142" points="8.2,-21.641 9.2,-22.64 9.2,-31.963 8.2,-32.962 7.2,-31.963 7.2,-22.64 			"/>
			<polygon fill="#414142" points="5.8,-21.641 6.8,-22.64 6.8,-31.963 5.8,-32.962 4.8,-31.963 4.8,-22.64 			"/>
			<polygon fill="#414142" points="3.4,-21.641 4.4,-22.64 4.4,-31.963 3.4,-32.962 2.4,-31.963 2.4,-22.64 			"/>
			<polygon fill="#414142" points="1,-21.641 2,-22.64 2,-31.963 1,-32.962 0,-31.963 0,-22.64 			"/>
		</g>
	</g>
</pattern>
<g id="StemAndScrew_A-04">
	<linearGradient id="stemGradient_A-04" gradientUnits="userSpaceOnUse" x1="133.2609" y1="106.284" x2="128.7263" y2="114.1381">
		<stop  offset="0" style="stop-color:#F2F2F2"/>
		<stop  offset="1" style="stop-color:#C6C7C9"/>
	</linearGradient>

		<rect x="122.1" y="109.525" fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" width="17.8" height="1.35"/>
	<g>
		<linearGradient id="screwGradient_A-04" gradientUnits="userSpaceOnUse" x1="133.8141" y1="106.415" x2="129.3734" y2="114.1066">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#B2B3B5"/>
		</linearGradient>
		<polygon fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" points="134.1,113.9343
			133.5527,113.7296 133.05,113.9343 132.5027,113.7296 132,113.9343 131.4527,113.7296 130.95,113.9343 130.4028,113.7296
			129.9,113.9343 129.1,113.9343 129.1,106.5657 129.6472,106.7704 130.15,106.5657 130.6972,106.7704 131.2,106.5657
			131.7472,106.7704 132.25,106.5657 132.7972,106.7704 133.3,106.5657 133.8472,106.7704 134.1,106.5657 		"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.1" y1="106.5657" x2="129.9" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.15" y1="106.5657" x2="130.95" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.2" y1="106.5657" x2="132" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.25" y1="106.5657" x2="133.05" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.6472" y1="106.7704" x2="130.4028" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.6972" y1="106.7704" x2="131.4527" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7472" y1="106.7704" x2="132.5027" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.7972" y1="106.7704" x2="133.5527" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.8472" y1="106.7704" x2="134.1" y2="109.0985"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.3" y1="106.5657" x2="134.1" y2="113.9343"/>
	</g>
</g>
<g id="Strap_A-04" style="mix-blend-mode: multiply;">
	<rect x="44.6704" y="12.6964" fill="#E6E6E6" width="55.2006" height="194.6012"/>
	<g>
		<path fill="lightgrey" d="M72.0818,10.7683c0,0,28.4735,0.2987,29.6841,1.5093s1.5094,25.5419,1.5094,25.5419v11.1317
			H40.8884V37.8195c0,0,0.2992-24.3312,1.5092-25.5418S72.0818,10.7683,72.0818,10.7683z"/>
		<path fill="lightgrey" d="M72.0818,216.8683c0,0,28.4735-0.2988,29.6841-1.5094s1.5094-33.1732,1.5094-33.1732v-11.1318
			H40.8884v11.1318c0,0,0.2987,31.9626,1.5094,33.1732S72.0818,216.8683,72.0818,216.8683z"/>
	</g>
	<g>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="41.97" y1="42.4615" x2="43.0516" y2="42.4615"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" stroke-dasharray="2.1113,1.0556" x1="44.1073" y1="42.4615" x2="100.5842" y2="42.4615"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="101.112" y1="42.4615" x2="102.1936" y2="42.4615"/>
	</g>
	<g>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="41.97" y1="177.5436" x2="43.0516" y2="177.5436"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" stroke-dasharray="2.1113,1.0556" x1="44.1073" y1="177.5436" x2="100.5842" y2="177.5436"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="101.112" y1="177.5436" x2="102.1936" y2="177.5436"/>
	</g>
</g>
<g id="Case_A-04">
  <linearGradient id="SVGID_A-04_9_" gradientUnits="userSpaceOnUse" x1="13.2262" y1="461.2334" x2="130.9374" y2="529.194" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
		<stop  offset="0" style="stop-color:#4B4B4B"/>
		<stop  offset="1" style="stop-color:#000000"/>
	</linearGradient>
	<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M20.0409,138.9364c6.2693,12.4476,10.6709,25.7508,13.0629,39.4813
		c2.5204,1.44,5.1191,2.7386,7.784,3.8895l0.0124-20.0826c0.0002-0.4698,0.3811-0.8505,0.8509-0.8503
		c0.1136,0,0.2261,0.0229,0.3308,0.0671l0.0013-0.0046c18.5412,10.8002,41.4566,10.8007,59.9982,0.0013l0.0007,0.0033
		c0.433-0.1829,0.9323,0.0198,1.1152,0.4528c0.0442,0.1046,0.067,0.2169,0.0671,0.3304l0.0124,20.0826
		c2.6647-1.1508,5.2632-2.4493,7.7834-3.8895c2.3927-13.7303,6.7942-27.0335,13.0628-39.4814
		c9.9847-17.9928,9.9847-39.8627,0-57.8555c-6.2686-12.4475-10.67-25.7501-13.0628-39.48c-2.52-1.4404-5.1185-2.7389-7.7834-3.8894
		l-0.0124,20.0825c0.0001,0.4694-0.3803,0.8501-0.8498,0.8502c-0.1143,0-0.2274-0.023-0.3325-0.0676v0.0039
		C83.5412,47.78,60.6257,47.7798,42.0845,58.5798l-0.0026-0.0033c-0.4317,0.1835-0.9305-0.0177-1.114-0.4494
		c-0.0448-0.1054-0.0678-0.2187-0.0677-0.3332l-0.0126-20.0832c-2.665,1.1507-5.2637,2.4491-7.784,3.8894
		C30.7111,55.3303,26.31,68.6335,20.042,81.0816c-9.9838,17.9908-9.9847,39.8583-0.0026,57.85"/>
	<g>
    <linearGradient id="SVGID_A-04_10_" gradientUnits="userSpaceOnUse" x1="43.5888" y1="445.8608" x2="100.5765" y2="544.5662" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" d="M129.0607,110.0088
			c0.0001,31.4681-25.5099,56.9781-56.978,56.9782c-31.4681,0-56.9781-25.5099-56.9782-56.978s25.5099-56.9781,56.978-56.9782
			h0.0001C103.5507,53.0308,129.0607,78.5407,129.0607,110.0088z"/>
    <linearGradient id="SVGID_A-04_11_" gradientUnits="userSpaceOnUse" x1="116.2784" y1="520.7292" x2="27.8864" y2="469.6962" gradientTransform="matrix(1 0 0 1 0.0003 -385.2045)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
    <circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" cx="72.0827" cy="110.0082" r="51.0246"/>
    <linearGradient id="SVGID_A-04_12_" gradientUnits="userSpaceOnUse" x1="47.5157" y1="452.6614" x2="96.6492" y2="537.7632" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M121.2076,110.0077c0.0001,27.1311-21.994,49.1254-49.1252,49.1254
			c-27.1312,0.0001-49.1253-21.994-49.1254-49.1252s21.994-49.1253,49.1252-49.1254c0.0001,0,0.0003,0,0.0004,0
			c27.1305-0.0004,49.1246,21.9929,49.125,49.1234C121.2076,110.0065,121.2076,110.0071,121.2076,110.0077z"/>
    <linearGradient id="SVGID_A-04_13_" gradientUnits="userSpaceOnUse" x1="96.1817" y1="536.9531" x2="47.9837" y2="453.4716" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M120.2727,110.0077c0,26.6146-21.5754,48.19-48.19,48.19s-48.19-21.5754-48.19-48.19
			s21.5753-48.1899,48.1899-48.19s48.19,21.5753,48.1901,48.1899C120.2727,110.0077,120.2727,110.0077,120.2727,110.0077z"/>
    <linearGradient id="SVGID_A-04_14_" gradientUnits="userSpaceOnUse" x1="25.309" y1="495.2123" x2="118.8552" y2="495.2123" gradientTransform="matrix(1 0 0 1 0.0001 -385.2045)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
    <circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" cx="72.0822" cy="110.0078" r="46.7731"/>
	</g>
</g>
<g id="Dial_A-04">
	<path id="Dial_color" fill="#FFFFFF" d="M118.8502,110.0084c-0.0001,25.8289-20.9386,46.7673-46.7675,46.7673
		c-25.8289-0.0001-46.7674-20.9386-46.7673-46.7675s20.9385-46.7673,46.7674-46.7673s46.7674,20.9385,46.7674,46.7674
		C118.8502,110.0083,118.8502,110.0084,118.8502,110.0084z M72.0828,107.7039c-1.2727,0-2.3045,1.0318-2.3045,2.3045
		s1.0318,2.3045,2.3045,2.3045s2.3045-1.0318,2.3045-2.3045S73.3556,107.7039,72.0828,107.7039L72.0828,107.7039z"/>
	<g id="Dial_ring">
    <linearGradient id="Dial_ring-2_1_" gradientUnits="userSpaceOnUse" x1="95.4702" y1="454.7048" x2="48.6954" y2="535.7211" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
			<stop  offset="1" style="stop-color:whitesmoke"/>
		</linearGradient>
		<path id="Dial_ring-2" fill="url(#Dial_ring-2_1_)" stroke="#B3B4B7" stroke-width="0.0133" stroke-miterlimit="1" d="
			M118.8498,110.0084c0,25.8287-20.9383,46.767-46.767,46.767s-46.767-20.9383-46.767-46.767s20.9383-46.767,46.767-46.767
			S118.8498,84.1797,118.8498,110.0084L118.8498,110.0084z M72.0828,68.9101c-22.698-0.0001-41.0983,18.4002-41.0984,41.0982
			s18.4002,41.0983,41.0982,41.0984s41.0984-18.4002,41.0984-41.0982v-0.0001C113.1811,87.3105,94.7808,68.9101,72.0828,68.9101
			C72.0829,68.9101,72.0829,68.9101,72.0828,68.9101z"/>

			<circle id="Outer_shoulder" fill="none" stroke="#B3B4B7" stroke-width="0.0333" stroke-miterlimit="10" cx="72.0828" cy="110.0084" r="46.767"/>

			<circle id="Inner_shoulder" fill="none" stroke="#75787A" stroke-width="0.0333" stroke-miterlimit="1" cx="72.0828" cy="110.0084" r="41.0982"/>
	</g>
	<g id="Sec_v3_">
		<g id="Sec-Ticks">

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.37" y1="64.8523" x2="67.646" y2="67.4708"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6811" y1="65.5955" x2="63.2286" y2="68.1701"/>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.094" y1="66.8245" x2="58.9078" y2="69.3284"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1309" y1="153.1089" x2="85.317" y2="150.605"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6616" y1="68.5252" x2="54.7333" y2="70.9312"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5626" y1="151.4074" x2="89.4929" y2="149.0024"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.4497" y1="73.2666" x2="46.9967" y2="75.397"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7758" y1="146.666" x2="97.2282" y2="144.5351"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7603" y1="76.2548" x2="43.5221" y2="78.2115"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4665" y1="143.6766" x2="100.7041" y2="141.7215"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.4018" y1="79.6123" x2="40.3595" y2="81.3741"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8223" y1="140.3188" x2="103.8666" y2="138.5564"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.415" y1="83.3017" x2="37.544" y2="84.8499"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8119" y1="136.6287" x2="106.6802" y2="135.0811"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6717" y1="91.5145" x2="33.0773" y2="92.5859"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5532" y1="128.4168" x2="111.1482" y2="127.3449"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9709" y1="95.9476" x2="31.4748" y2="96.7614"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2546" y1="123.9842" x2="112.7507" y2="123.1693"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7409" y1="100.5334" x2="30.3178" y2="101.0807"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4833" y1="119.397" x2="113.9071" y2="118.8488"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="26.9986" y1="105.2233" x2="29.6172" y2="105.4984"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2256" y1="114.7071" x2="114.6083" y2="114.432"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="26.9986" y1="114.7061" x2="29.6172" y2="114.4314"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2256" y1="105.2233" x2="114.6083" y2="105.4984"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7409" y1="119.396" x2="30.3178" y2="118.8488"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4815" y1="100.5344" x2="113.9071" y2="101.0807"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9696" y1="123.9822" x2="31.4735" y2="123.1693"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2527" y1="95.9476" x2="112.7507" y2="96.7604"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6717" y1="128.4149" x2="33.0767" y2="127.3449"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5532" y1="91.5145" x2="111.1482" y2="92.5849"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4131" y1="136.6281" x2="37.544" y2="135.0805"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8099" y1="83.3017" x2="106.6802" y2="84.8489"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.3999" y1="140.3188" x2="40.3576" y2="138.5564"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8223" y1="79.6113" x2="103.8646" y2="81.3731"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7583" y1="143.6753" x2="43.5201" y2="141.7196"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4648" y1="76.2545" x2="100.703" y2="78.2103"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.4483" y1="146.6643" x2="46.9958" y2="144.5334"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.774" y1="73.2655" x2="97.2264" y2="75.3948"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6602" y1="151.4057" x2="54.7318" y2="149.0007"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5627" y1="68.524" x2="89.4911" y2="70.929"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0932" y1="153.1072" x2="58.9071" y2="150.6033"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1296" y1="66.8226" x2="85.3158" y2="69.3262"/>
			</g>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5437" y1="65.5935" x2="80.9956" y2="68.1685"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8529" y1="64.8503" x2="76.5768" y2="67.4689"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.37" y1="155.1645" x2="67.646" y2="152.5459"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6811" y1="154.4212" x2="63.2286" y2="151.8466"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5437" y1="154.4232" x2="80.9956" y2="151.8482"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8529" y1="155.1664" x2="76.5768" y2="152.5479"/>
		</g>
		<g id="Indices">

				<rect x="70.0925" y="64.6423" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9506" height="2.6335"/>

				<rect x="70.0925" y="152.7425" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9506" height="2.6329"/>

				<rect x="26.7018" y="108.0334" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6322" height="3.9506"/>

				<rect x="114.7984" y="108.0334" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6342" height="3.9506"/>

				<rect x="48.7702" y="70.5428" transform="matrix(0.8659 -0.5002 0.5002 0.8659 -29.228 34.6895)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6334" height="2.6327"/>

				<rect x="92.8194" y="146.8406" transform="matrix(0.8662 -0.4997 0.4997 0.8662 -61.4388 66.8633)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6331" height="2.6341"/>

				<rect x="32.647" y="86.67" transform="matrix(0.4997 -0.8662 0.8662 0.4997 -59.222 73.4393)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6336" height="2.6337"/>

				<rect x="108.9453" y="130.7183" transform="matrix(0.5006 -0.8657 0.8657 0.5006 -59.2348 161.3919)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6338" height="2.6339"/>

				<rect x="32.6364" y="130.7066" transform="matrix(0.8662 -0.4996 0.4996 0.8662 -61.4205 34.6229)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6333" height="2.6331"/>

				<rect x="108.9372" y="86.6667" transform="matrix(0.8661 -0.4998 0.4998 0.8661 -29.2159 66.8854)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6345" height="2.6332"/>

				<rect x="48.7738" y="146.8372" transform="matrix(0.4999 -0.8661 0.8661 0.4999 -103.2636 117.4752)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6326" height="2.633"/>

				<rect x="92.8186" y="70.5459" transform="matrix(0.5002 -0.8659 0.8659 0.5002 -15.1777 117.4294)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6342" height="2.6332"/>
		</g>
		<g>
			<path fill="#D9D8D6" d="M63.8825,148.3477l-0.1112-0.1051c-0.058-0.0506-0.1056-0.1121-0.14-0.181
				c-0.0238-0.0549-0.0293-0.1161-0.0158-0.1744c0.0154-0.0862,0.0684-0.1611,0.1445-0.2044
				c0.082-0.0448,0.1781-0.0566,0.2685-0.0329c0.0963,0.0199,0.1841,0.0688,0.2519,0.14l-0.041,0.1908
				c-0.0549-0.0905-0.1437-0.1553-0.2467-0.18c-0.0475-0.0123-0.0977-0.0092-0.1433,0.0091
				c-0.0378,0.0141-0.0657,0.0466-0.0738,0.0862c-0.0076,0.0367-0.0012,0.0748,0.0178,0.1071
				c0.028,0.0465,0.0633,0.0882,0.1046,0.1234l0.112,0.1032c0.1141,0.0874,0.1701,0.2311,0.145,0.3727
				c-0.0152,0.0875-0.0676,0.1641-0.1436,0.21c-0.0802,0.0458-0.1752,0.0583-0.2646,0.0351
				c-0.1147-0.0238-0.2182-0.0852-0.2941-0.1745l0.0458-0.2135c0.0489,0.12,0.1524,0.2092,0.2783,0.24
				c0.0472,0.012,0.0972,0.0065,0.1407-0.0156c0.0394-0.0194,0.0675-0.0559,0.0762-0.0989
				C64.0091,148.5126,63.9718,148.4339,63.8825,148.3477z"/>
			<path fill="#D9D8D6" d="M65.9876,148.0377l0.1688,0.03l-0.69,1.1011l-0.0371-0.0068l-0.2141-1.03l-0.5625,0.8909l-0.0365-0.0065
				l-0.2634-1.272l0.17,0.0305l0.18,0.8727l0.4736-0.7555l0.16,0.0287l0.1835,0.8736L65.9876,148.0377z"/>
			<path fill="#D9D8D6" d="M66.2637,148.0732l0.17,0.0254l-0.1778,1.1874l-0.17-0.0257L66.2637,148.0732z"/>
			<path fill="#D9D8D6" d="M66.875,148.8648l-0.1188-0.096c-0.0617-0.0463-0.1139-0.104-0.1538-0.17
				c-0.0281-0.0528-0.0383-0.1134-0.0292-0.1725c0.0086-0.0873,0.0555-0.1663,0.1281-0.2155
				c0.0784-0.0506,0.1731-0.0698,0.265-0.0537c0.0975,0.0125,0.189,0.0544,0.2622,0.12l-0.0261,0.1933
				c-0.0617-0.0862-0.1553-0.1442-0.26-0.1611c-0.0485-0.0085-0.0984-0.0012-0.1424,0.0208
				c-0.0364,0.017-0.0617,0.0513-0.067,0.0911c-0.0044,0.0373,0.005,0.0749,0.0263,0.1058c0.0315,0.0442,0.0699,0.083,0.1138,0.1149
				l0.12,0.0941c0.1206,0.0781,0.1875,0.217,0.1734,0.36c-0.0084,0.0882-0.0547,0.1685-0.1268,0.22
				c-0.0764,0.0521-0.1701,0.0722-0.2611,0.056c-0.1162-0.0148-0.2241-0.0679-0.3066-0.151l0.0288-0.2165
				c0.0583,0.1157,0.1683,0.1967,0.2961,0.2178c0.0481,0.0081,0.0975-0.0015,0.1391-0.027c0.0378-0.0222,0.063-0.0607,0.0684-0.1042
				C67.014,149.0191,66.9709,148.9437,66.875,148.8648z"/>
			<path fill="#D9D8D6" d="M67.6736,148.9625l-0.1208-0.0934c-0.0626-0.0449-0.1161-0.1014-0.1575-0.1664
				c-0.029-0.0523-0.0405-0.1125-0.0327-0.1718c0.0069-0.0874,0.0521-0.1672,0.1235-0.2181
				c0.0773-0.0525,0.1717-0.0736,0.264-0.0589c0.0978,0.0102,0.1902,0.0502,0.2646,0.1145l-0.0218,0.1937
				c-0.0638-0.0847-0.1587-0.1406-0.2637-0.1553c-0.0485-0.0073-0.0981,0.0008-0.1417,0.0232
				c-0.0361,0.018-0.0606,0.053-0.0651,0.0931c-0.0034,0.0373,0.0066,0.0746,0.0283,0.1051
				c0.0326,0.0435,0.0719,0.0815,0.1165,0.1126l0.1218,0.0915c0.1221,0.0759,0.1917,0.2134,0.1806,0.3567
				c-0.0067,0.0883-0.0512,0.1694-0.1222,0.2223c-0.0753,0.0537-0.1687,0.0757-0.26,0.0612
				c-0.1166-0.0124-0.2257-0.0634-0.31-0.1449l0.0246-0.2167c0.0606,0.1143,0.172,0.1928,0.3,0.2115
				c0.0484,0.007,0.0978-0.0037,0.139-0.03c0.0371-0.0231,0.0615-0.0622,0.0658-0.1057
				C67.8155,149.1141,67.7711,149.0396,67.6736,148.9625z"/>
			<path fill="#D9D8D6" d="M77.2187,148.1764l0.16-0.02l0.1458,1.1916l-0.1716,0.0211l-0.1132-0.9273l-0.31,0.5055l-0.0316,0.0039
				l-0.4267-0.415l0.1133,0.927l-0.17,0.0208l-0.1461-1.1913l0.1614-0.02l0.456,0.4407L77.2187,148.1764z"/>
			<path fill="#D9D8D6" d="M77.9705,148.0595l0.12-0.0185l0.7171,1.1106l-0.1742,0.027l-0.2125-0.3271l-0.5061,0.0787
				l-0.0938,0.3743l-0.1744,0.0274L77.9705,148.0595z M78.3273,148.7112l-0.2581-0.4l-0.1107,0.457L78.3273,148.7112z"/>
			<path fill="#D9D8D6" d="M78.9392,149.1262l-0.221-1.1783l0.3974-0.0745c0.1297-0.0307,0.2649-0.0305,0.3945,0.0006
				c0.1022,0.0304,0.1935,0.0896,0.263,0.1706c0.072,0.0822,0.1204,0.1824,0.14,0.29c0.0148,0.0777,0.0137,0.1575-0.0033,0.2347
				c-0.0163,0.0772-0.0485,0.1503-0.0944,0.2145c-0.0465,0.0669-0.1065,0.1232-0.1761,0.1654
				c-0.0364,0.0233-0.0752,0.0425-0.1158,0.0575c-0.0691,0.0211-0.1396,0.0375-0.211,0.0489L78.9392,149.1262z M79.126,148.027
				l-0.2109,0.04l0.165,0.8772l0.2158-0.04c0.0664-0.0108,0.1313-0.0289,0.1937-0.0541c0.0388-0.0172,0.0753-0.0395,0.1084-0.0661
				c0.0282-0.0237,0.053-0.0512,0.0736-0.0817c0.0678-0.1009,0.0913-0.2251,0.0651-0.3437
				c-0.0266-0.1644-0.148-0.2974-0.3093-0.3388c-0.0401-0.011-0.0815-0.0164-0.123-0.016
				C79.2445,148.0071,79.1848,148.0148,79.126,148.027z"/>
			<path fill="#D9D8D6" d="M79.9762,147.7057l0.665-0.1438l0.0325,0.1494l-0.4973,0.1074l0.0774,0.358l0.48-0.1041l0.0325,0.15
				l-0.48,0.1038l0.0788,0.3645l0.5132-0.111l0.0323,0.1494l-0.6809,0.1475L79.9762,147.7057z"/>
		</g>
	</g>
	<g id="Numerals">
		<g>
			<path fill="#231F20" d="M51.7652,76.617h1.0287v7.1852h-1.0287V76.617z"/>
			<path fill="#231F20" d="M55.2412,76.617H56.27v7.1852h-1.0287L55.2412,76.617L55.2412,76.617z"/>
		</g>
		<g>
			<path fill="#231F20" d="M39.0083,89.6105h1.0287v7.1851h-1.0287V89.6105z"/>
			<path fill="#231F20" d="M43.5139,89.5177c0.6931,0.0202,1.3196,0.4178,1.633,1.0363c0.8606,1.6583,0.8606,3.6317,0,5.29
				c-0.4796,0.9283-1.6209,1.2921-2.5492,0.8125c-0.3415-0.1764-0.6211-0.4526-0.8017-0.7919
				c-0.8507-1.6733-0.843-3.654,0.0206-5.3207C42.1535,89.9184,42.8036,89.5254,43.5139,89.5177z M43.5239,90.495h-0.0514
				c-0.4328,0.0266-0.8052,0.3153-0.9387,0.7278c-0.2577,0.6244-0.3762,1.2975-0.3471,1.9724
				c-0.0303,0.6835,0.0856,1.3655,0.34,2.0006c0.1352,0.5184,0.665,0.829,1.1834,0.6938c0.3398-0.0886,0.6052-0.354,0.6938-0.6938
				c0.2562-0.624,0.3738-1.2961,0.3447-1.97c0.0273-0.6791-0.0857-1.3565-0.3318-1.99c-0.2214-0.4937-0.519-0.7405-0.8927-0.7406
				L43.5239,90.495z"/>
		</g>
		<path fill="#231F20" d="M36.0011,113.551l-0.6326-0.7457c0.5259-0.3314,0.9963-0.7437,1.3938-1.2216
			c0.3702-0.4271,0.6424-0.9301,0.7973-1.4736c-0.3459,0.2078-0.7437,0.313-1.1471,0.3035
			c-0.5361,0.0054-1.0493-0.2171-1.4118-0.6121c-0.8-0.8416-0.7829-2.1676,0.0386-2.9883c0.4039-0.409,0.9581-0.634,1.5327-0.6223
			c0.6379-0.0182,1.25,0.252,1.6665,0.7354c0.4447,0.5259,0.676,1.1995,0.6481,1.8877c-0.0203,0.9388-0.3018,1.8533-0.8128,2.6411
			C37.5643,112.3124,36.8527,113.032,36.0011,113.551z M37.7601,109.0866c0.0307-0.177,0.0513-0.3557,0.0618-0.535
			c0.0153-0.3709-0.1085-0.7341-0.3473-1.0183c-0.2224-0.26-0.5503-0.4056-0.8923-0.3961c-0.3103-0.009-0.6101,0.1133-0.8255,0.3369
			c-0.2185,0.2265-0.3363,0.5316-0.3266,0.8461c-0.002,0.3074,0.1271,0.6011,0.355,0.8075c0.226,0.2223,0.5316,0.3447,0.8485,0.34
			C37.0396,109.4604,37.4332,109.3272,37.7601,109.0866z"/>
		<path fill="#231F20" d="M41.1455,122.9192c0.2694-0.0005,0.5363,0.0516,0.7857,0.1533c0.2469,0.0989,0.4735,0.2425,0.6684,0.4234
			c0.1928,0.1789,0.3487,0.3938,0.4591,0.6325c0.1121,0.2411,0.1696,0.5041,0.1684,0.77c0.0057,0.5242-0.2134,1.0258-0.6019,1.3778
			c0.3057,0.2081,0.5632,0.4795,0.7549,0.7958c0.1668,0.2993,0.2514,0.6374,0.245,0.98c0.0017,0.2924-0.0665,0.581-0.1989,0.8417
			c-0.1334,0.2629-0.3152,0.4984-0.5358,0.694c-0.2309,0.2046-0.4971,0.3654-0.7857,0.4745
			c-0.3028,0.1162-0.6246,0.1751-0.949,0.1735c-0.3311,0.0028-0.6598-0.056-0.9694-0.1735
			c-0.2877-0.1086-0.5538-0.2675-0.7858-0.4693c-0.2214-0.1935-0.4016-0.4295-0.53-0.694c-0.129-0.2636-0.1954-0.5534-0.194-0.8469
			c-0.0118-0.6146,0.2636-1.1995,0.7449-1.5819c0.0705-0.0676,0.1494-0.1259,0.2348-0.1734
			c-0.3807-0.366-0.5978-0.8699-0.6022-1.398c-0.0012-0.2659,0.0564-0.5289,0.1685-0.77c0.1083-0.2359,0.2607-0.449,0.449-0.6276
			c0.1933-0.1806,0.4181-0.3241,0.6632-0.4235C40.5919,122.9718,40.8675,122.9179,41.1455,122.9192z M41.1455,126.7459
			c-0.1841,0-0.367,0.0311-0.5408,0.0918c-0.1687,0.0567-0.326,0.1432-0.4643,0.2552c-0.1313,0.1072-0.2405,0.2388-0.3215,0.3877
			c-0.0818,0.1503-0.124,0.3189-0.1225,0.49c-0.0017,0.1705,0.0386,0.3388,0.1173,0.49c0.0788,0.1503,0.1863,0.2838,0.3164,0.3928
			c0.1372,0.1148,0.2947,0.203,0.4643,0.26c0.1806,0.0618,0.3704,0.0928,0.5613,0.0918c0.1825,0.0002,0.3636-0.0309,0.5356-0.0918
			c0.1669-0.0574,0.3224-0.1438,0.4593-0.2552c0.1313-0.1071,0.2404-0.2388,0.3214-0.3876c0.0826-0.1535,0.1248-0.3256,0.1224-0.5
			c0.0015-0.1711-0.0406-0.3397-0.1224-0.49c-0.0819-0.1497-0.1929-0.2816-0.3265-0.3877c-0.2824-0.2223-0.6306-0.3443-0.99-0.347
			C41.1555,126.7459,41.1455,126.7459,41.1455,126.7459z M41.9006,124.2459c-0.2002-0.1985-0.4734-0.3055-0.7551-0.2959
			c-0.1524-0.0021-0.3036,0.0274-0.444,0.0866c-0.1264,0.0536-0.2408,0.1318-0.3367,0.23c-0.0891,0.0911-0.1601,0.1984-0.2091,0.316
			c-0.0472,0.1133-0.0715,0.2347-0.0715,0.3574c-0.0005,0.1336,0.0273,0.2657,0.0817,0.3877
			c0.0527,0.1198,0.1271,0.2288,0.2194,0.3216c0.0951,0.094,0.2078,0.1685,0.3315,0.2193c0.136,0.0556,0.2818,0.0833,0.4287,0.0814
			c0.1381,0.001,0.275-0.025,0.4031-0.0765c0.1245-0.0501,0.2386-0.1227,0.3367-0.2142c0.0977-0.0905,0.1759-0.1999,0.23-0.3215
			c0.055-0.1253,0.0828-0.2609,0.0816-0.3978C42.1905,124.6793,42.0844,124.4309,41.9006,124.2459z"/>
		<path fill="#231F20" d="M51.9176,136.0734h4.65l-3.2515,7.2695l-0.92-0.3876l2.6277-5.9h-3.1062
			C51.9176,137.0553,51.9176,136.0734,51.9176,136.0734z"/>
		<path fill="#231F20" d="M90.1516,135.7206h3.1888v0.9156h-2.2528v1.8156c0.072-0.0068,0.1455-0.01,0.221-0.01
			c0.6341-0.0232,1.2516,0.2051,1.718,0.6353c0.4466,0.4172,0.6921,1.0065,0.6737,1.6174c0.023,0.6193-0.2192,1.219-0.6659,1.6486
			c-0.4681,0.4325-1.089,0.661-1.7258,0.635c-0.5914-0.0021-1.1736-0.1468-1.6971-0.4218v-1.0595
			c0.4456,0.3128,0.973,0.4881,1.5172,0.5042c0.3968,0.0125,0.7842-0.1222,1.0877-0.3782c0.5115-0.4171,0.588-1.1698,0.171-1.6813
			c-0.0614-0.0752-0.1317-0.1427-0.2094-0.201c-0.341-0.2628-0.763-0.3983-1.1932-0.3831
			c-0.2818-0.0183-0.5644,0.0166-0.8333,0.1028L90.1516,135.7206z"/>
		<path fill="#231F20" d="M104.6876,126.3177v1.1021h1.0611v1.03h-1.0611v1.7449h-1.02v-1.7449h-2.9388l2.7549-5.49h1.1532
			l-2.2449,4.4592h1.2756v-1.1013C103.6676,126.3177,104.6876,126.3177,104.6876,126.3177z"/>
		<path fill="#231F20" d="M106.7655,109.2871h0.0615c0.3635,0.0247,0.7249-0.073,1.0263-0.2777
			c0.2403-0.197,0.3713-0.4974,0.3522-0.8075c0.0096-0.2973-0.1163-0.583-0.3421-0.7766c-0.2518-0.2072-0.5716-0.3135-0.8974-0.2983
			c-0.4366,0.0171-0.8631,0.137-1.2446,0.35v-0.9823c0.425-0.2107,0.8937-0.3182,1.368-0.3138
			c0.569-0.0318,1.1288,0.1537,1.5662,0.519c0.3905,0.3655,0.6003,0.8844,0.5735,1.4186c0.0106,0.3202-0.0659,0.6373-0.2213,0.9174
			c-0.1733,0.2725-0.4165,0.4935-0.7043,0.64c0.2366,0.0802,0.449,0.2193,0.6171,0.4041c0.1368,0.172,0.2397,0.3685,0.3033,0.5789
			c0.073,0.2332,0.1095,0.4763,0.1081,0.7206c0.0178,0.5839-0.2098,1.1485-0.6275,1.5568c-0.4225,0.4119-0.9944,0.634-1.5842,0.6152
			c-0.5508-0.0014-1.0928-0.1375-1.579-0.3962v-1.1212c0.4674,0.3161,1.015,0.4927,1.579,0.5093
			c0.3088,0.0141,0.6103-0.0971,0.8359-0.3085c0.2152-0.2164,0.3299-0.5131,0.3163-0.818c0.0044-0.2719-0.0886-0.5364-0.2623-0.7457
			c-0.0931-0.1124-0.2099-0.2029-0.3421-0.2649c-0.2626-0.0861-0.5345-0.1405-0.81-0.162l-0.0924-0.01L106.7655,109.2871z"/>
		<path fill="#231F20" d="M102.8276,95.5726h2.7351v0.9926h-4.5467v-0.0719l0.4319-0.5092
			c0.6757-0.8367,1.2132-1.5465,1.6125-2.1294c0.302-0.4148,0.5638-0.8574,0.7818-1.3218c0.118-0.2802,0.18-0.5807,0.1826-0.8847
			c0.017-0.3575-0.1067-0.7074-0.3447-0.9747c-0.238-0.2486-0.5715-0.3825-0.9153-0.3676c-0.3019,0.004-0.5966,0.0921-0.8511,0.2545
			c-0.2969,0.1861-0.5532,0.4301-0.7536,0.7176v-1.3065c0.4775-0.4245,1.0895-0.6667,1.7281-0.684
			c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4101,0.4274,0.6301,1.0025,0.61,1.5945c-0.0042,0.3137-0.0553,0.625-0.1517,0.9235
			c-0.1338,0.3971-0.3142,0.7769-0.5374,1.1315c-0.3948,0.6126-0.833,1.1963-1.3111,1.7464L102.8276,95.5726z"/>
		<path fill="#231F20" d="M90.8905,76.617h1.0288v7.1853h-1.0288V76.617z"/>
		<g>
			<path fill="#231F20" d="M68.9789,71.7816h1.0287v7.1851h-1.0287V71.7816z"/>
			<path fill="#231F20" d="M72.9818,77.9741h2.7351v0.9926H71.17v-0.0719l0.432-0.5092c0.6754-0.8367,1.2129-1.5465,1.6125-2.1294
				c0.302-0.4148,0.5638-0.8574,0.7818-1.3218c0.1181-0.2801,0.1802-0.5807,0.1827-0.8847c0.017-0.3575-0.1067-0.7073-0.3447-0.9746
				c-0.2379-0.2487-0.5715-0.3827-0.9153-0.3677c-0.302,0.004-0.5969,0.0921-0.8515,0.2545
				c-0.2968,0.1861-0.5531,0.4302-0.7535,0.7176V72.373c0.4776-0.4244,1.0896-0.6667,1.7283-0.684
				c0.5822-0.0185,1.1452,0.2094,1.5507,0.6275c0.4101,0.4275,0.6301,1.0025,0.61,1.5946
				c-0.0042,0.3136-0.0554,0.6249-0.1517,0.9234c-0.1337,0.3971-0.3141,0.7769-0.5373,1.1315
				c-0.3949,0.6126-0.833,1.1962-1.3111,1.7464L72.9818,77.9741z"/>
		</g>
		<path fill="#231F20" d="M72.7286,140.9691l0.1025-0.0719l0.6223,0.7815c-0.508,0.3198-0.9678,0.7104-1.3654,1.16
			c-0.3708,0.4349-0.6546,0.937-0.8359,1.479c0.3499-0.1877,0.7398-0.2883,1.1368-0.2933c0.5404-0.0109,1.0601,0.2079,1.43,0.6019
			c0.3848,0.3935,0.5945,0.9258,0.5813,1.4761c0.0104,0.575-0.2188,1.1283-0.6327,1.5275
			c-0.4047,0.4114-0.9608,0.6383-1.5378,0.6275c-0.6256,0.0218-1.2276-0.2401-1.6382-0.7125
			c-0.4331-0.522-0.6559-1.1868-0.6247-1.8644c0.0022-0.5881,0.1111-1.1708,0.3214-1.72c0.2201-0.5813,0.5327-1.1233,0.9257-1.605
			C71.6514,141.8247,72.1613,141.358,72.7286,140.9691z M71.031,145.3821c-0.0287,0.1785-0.0424,0.3592-0.041,0.54
			c-0.0141,0.3653,0.1118,0.7221,0.3521,0.9976c0.228,0.2578,0.5588,0.401,0.9028,0.3909c0.3069,0.0093,0.6033-0.1123,0.8153-0.3343
			c0.2159-0.2266,0.3318-0.5305,0.3216-0.8433c0.0123-0.3166-0.1125-0.6231-0.3424-0.8411
			c-0.2471-0.2213-0.5713-0.3366-0.9026-0.3212c-0.1779-0.0025-0.3547,0.0271-0.5221,0.0872
			C71.4086,145.1436,71.2127,145.2523,71.031,145.3821L71.031,145.3821z"/>
	</g>
	<g id="S_Logo">
		<g id="Printed">
			<path fill="#231F20" d="M66.4707,93.0522c0.8577,0.0621,1.069,0.17,1.069,0.8338c0,0.48,0.0186,0.95-1.2539,0.95
				c-0.7387,0-1.2286-0.0153-1.2286-0.9652h0.7409c0,0.3008,0.1081,0.3327,0.4877,0.3327c0.3626,0,0.4814-0.0241,0.4814-0.2666
				c0-0.2518-0.0426-0.2476-0.4053-0.2707l-0.17-0.0112c-0.7139-0.05-1.1315-0.0466-1.1315-0.8768s0.4674-0.8829,1.2253-0.8829
				c0.6315,0,1.1722,0.01,1.1722,0.81v0.1205h-0.74c0-0.2972-0.1238-0.2972-0.4323-0.2972c-0.418,0-0.4535,0.0849-0.4535,0.2464
				c0,0.2324,0.1117,0.24,0.3177,0.2546L66.4707,93.0522z"/>
			<path fill="#231F20" d="M71.3546,91.9166H72.13l-0.64,2.8962h-1.1172l-0.3939-1.8146h-0.03l-0.4218,1.8146h-1.1029l-0.625-2.8962
				h0.7822l0.4173,2.2324h0.027l0.5446-2.2324h0.8025l0.52,2.2324h0.0244L71.3546,91.9166z"/>
			<path fill="#231F20" d="M73.2631,94.8128h-0.774v-2.8962h0.774V94.8128z"/>
			<path fill="#231F20" d="M75.2105,93.0522c0.8581,0.0621,1.0693,0.17,1.0693,0.8338c0,0.48,0.0209,0.95-1.2529,0.95
				c-0.738,0-1.23-0.0153-1.23-0.9652h0.7426c0,0.3008,0.1071,0.3327,0.487,0.3327c0.3626,0,0.4834-0.0241,0.4834-0.2666
				c0-0.2518-0.0433-0.2476-0.4079-0.2707l-0.1693-0.0112c-0.7138-0.05-1.13-0.0466-1.13-0.8768s0.4658-0.8829,1.224-0.8829
				c0.6315,0,1.1726,0.01,1.1726,0.81v0.1205h-0.741c0-0.2972-0.1243-0.2972-0.4316-0.2972c-0.418,0-0.4532,0.0849-0.4532,0.2464
				c0,0.2324,0.1127,0.24,0.3174,0.2546L75.2105,93.0522z"/>
			<path fill="#231F20" d="M78.1302,93.0522c0.8567,0.0621,1.0686,0.17,1.0686,0.8338c0,0.48,0.02,0.95-1.2542,0.95
				c-0.7367,0-1.2272-0.0153-1.2272-0.9652h0.74c0,0.3008,0.1094,0.3327,0.487,0.3327c0.3626,0,0.4828-0.0241,0.4828-0.2666
				c0-0.2518-0.042-0.2476-0.4047-0.2707l-0.1712-0.0112c-0.7132-0.05-1.13-0.0466-1.13-0.8768s0.4677-0.8829,1.2236-0.8829
				c0.6341,0,1.1739,0.01,1.1739,0.81v0.1205h-0.7416c0-0.2972-0.1237-0.2972-0.4323-0.2972c-0.416,0-0.4508,0.0849-0.4508,0.2464
				c0,0.2324,0.1116,0.24,0.3144,0.2546L78.1302,93.0522z"/>
			<path fill="#231F20" d="M65.3785,98.2841v-2.83h1.5938c0.3549-0.0414,0.7123,0.0542,0.999,0.2675
				c0.2111,0.2974,0.3047,0.6624,0.2631,1.0247c0.0423,0.4238-0.039,0.8508-0.2341,1.2294c-0.2459,0.2406-0.589,0.3545-0.93,0.3086
				L65.3785,98.2841z M65.7669,98.0141h1.1221c0.2818,0.0388,0.5676-0.034,0.7965-0.2027c0.1519-0.2763,0.2138-0.5931,0.1771-0.9062
				c0.0353-0.3333-0.0177-0.67-0.1536-0.9764c-0.1039-0.1376-0.3506-0.2054-0.7419-0.2054h-1.2L65.7669,98.0141z"/>
			<path fill="#231F20" d="M69.2076,95.7232v0.9645h1.7471v0.2689h-1.7471v1.0573h1.8233v0.27h-2.2122v-2.83h2.2117v0.2693
				C71.0304,95.7232,69.2076,95.7232,69.2076,95.7232z"/>
			<path fill="#231F20" d="M72.1228,95.4539v2.5338h1.7693v0.2967h-2.157v-2.83L72.1228,95.4539z"/>
			<path fill="#231F20" d="M75.1285,95.7505v2.5336h-0.3887v-2.5336H73.619v-0.2966h2.6205v0.2966H75.1285z"/>
			<path fill="#231F20" d="M78.4941,97.6848h-1.7429l-0.2636,0.5993h-0.41l1.26-2.83h0.5449l1.2843,2.83h-0.406L78.4941,97.6848z
				 M78.3805,97.444l-0.7624-1.73l-0.7552,1.73H78.3805z"/>
		</g>
		<g id="Logo">
			<path fill="#231F20" d="M76.3076,88.8832c-0.0159-0.0587-0.0351-0.1163-0.0576-0.1728
				c-0.0726-0.1941-0.2089-0.5254-0.2738-0.6836c-0.3213-0.7526-0.6876-1.4851-1.097-2.1936
				c-0.4407-0.764-0.932-1.4977-1.4707-2.1962c-0.0492-0.0644-0.1393-0.1816-0.2282-0.29c-0.0407-0.0542-0.0841-0.1064-0.12-0.15
				c-0.0308-0.0406-0.0646-0.0787-0.1012-0.1141c-0.2194-0.2076-0.5099-0.3233-0.8119-0.3233h-0.0016
				c-0.2071,0.0004-0.4105,0.0549-0.59,0.1582c-0.0715,0.0424-0.1385,0.0918-0.2,0.1477l-0.108,0.1l0.0077,0.01
				c-0.1223,0.1477-0.3173,0.404-0.3847,0.4908c-1.0684,1.391-1.9492,2.9163-2.62,4.5369c-0.026,0.0612-0.08,0.1891-0.1285,0.3025
				c-0.0248,0.0562-0.0476,0.11-0.0655,0.1514c-0.0173,0.0432-0.0277,0.0663-0.0378,0.0894
				c-0.2314,0.6109,0.0762,1.2938,0.6871,1.5252c0.023,0.0087,0.0463,0.0167,0.0698,0.024c0.0882,0.0264,0.179,0.0428,0.2708,0.049
				c1.0203,0.1607,2.0518,0.2405,3.0847,0.2389c0.6838,0.0005,1.3672-0.0343,2.0474-0.1042c0.1962-0.02,0.7907-0.0909,1.2232-0.1614
				c0.3276-0.0625,0.6099-0.2685,0.7693-0.5614c0.012-0.0213,0.02-0.0377,0.0257-0.05l0.0068-0.0146l0.0016-0.0053l0.0036-0.0032
				v-0.0036l0.002-0.0024c0.0099-0.019,0.0187-0.0386,0.0263-0.0586c0.0668-0.149,0.1012-0.3104,0.101-0.4737
				C76.3383,89.057,76.3281,88.969,76.3076,88.8832z M76.11,89.5649c-0.0121,0.0266-0.02,0.044-0.0257,0.0541l-0.002,0.0027v0.0025
				l-0.0015,0.0008c-0.0034,0.0078-0.0122,0.0276-0.0306,0.061c-0.1392,0.2561-0.3849,0.4371-0.6707,0.4943
				c-0.4258,0.0687-1.0218,0.14-1.2158,0.1607c-0.6751,0.068-1.3532,0.1019-2.0317,0.1014c-1.0277,0.0025-2.054-0.0774-3.069-0.2389
				c-0.0834-0.0046-0.1659-0.0187-0.2461-0.042c-0.4361-0.1349-0.7335-0.538-0.7337-0.9945
				c-0.0003-0.1262,0.023-0.2513,0.0686-0.369c0.0072-0.02,0.016-0.041,0.0352-0.0858c0.0162-0.04,0.04-0.0946,0.0644-0.1514
				c0.0492-0.1134,0.1031-0.2415,0.1289-0.3043c0.3319-0.8014,0.716-1.5801,1.15-2.3312c0.4351-0.7561,0.9205-1.4822,1.4529-2.1733
				c0.0739-0.0961,0.3092-0.4064,0.416-0.5295c0.0155-0.0188,0.0328-0.036,0.0518-0.0513c0.0532-0.0504,0.1123-0.0943,0.1758-0.1308
				c0.3983-0.2305,0.9007-0.1721,1.2354,0.1437c0.0318,0.0326,0.0615,0.0673,0.0888,0.1038
				c0.0367,0.0415,0.0776,0.0928,0.1208,0.1472c0.0853,0.1074,0.177,0.2243,0.2252,0.2879c1.0298,1.3398,1.8859,2.8045,2.548,4.3592
				c0.0654,0.1554,0.2011,0.4871,0.2725,0.6763c0.0206,0.0508,0.038,0.1028,0.052,0.1557c0.0187,0.0756,0.028,0.1532,0.0277,0.2311
				C76.1967,89.2896,76.167,89.4324,76.11,89.5649L76.11,89.5649z"/>
			<path fill="none" d="M76.1176,88.7585c-0.0714-0.1892-0.2071-0.5209-0.2725-0.6763c-0.6621-1.5547-1.5182-3.0194-2.548-4.3592
				c-0.0482-0.0636-0.14-0.18-0.2252-0.2879c-0.0432-0.0544-0.0841-0.1057-0.1208-0.1472
				c-0.1877-0.2541-0.4887-0.3991-0.8044-0.3875c-0.1826,0.0003-0.3619,0.0485-0.52,0.14
				c-0.0635,0.0365-0.1226,0.0804-0.1758,0.1308c-0.019,0.0153-0.0363,0.0325-0.0518,0.0513
				c-0.1068,0.1231-0.3421,0.4334-0.416,0.5295c-0.5324,0.6911-1.0178,1.4172-1.4529,2.1733
				c-0.434,0.7511-0.8181,1.5298-1.15,2.3312c-0.0258,0.0628-0.08,0.1909-0.1289,0.3043c-0.0241,0.0568-0.0482,0.1109-0.0644,0.1514
				c-0.0192,0.0448-0.028,0.0661-0.0352,0.0858c-0.0456,0.1177-0.0689,0.2428-0.0686,0.369
				c0.0002,0.4565,0.2976,0.8596,0.7337,0.9945c0.0802,0.0233,0.1627,0.0374,0.2461,0.042c1.015,0.1615,2.0413,0.2414,3.069,0.2389
				c0.6785,0.0005,1.3566-0.0334,2.0317-0.1014c0.194-0.02,0.79-0.092,1.2158-0.1607c0.2858-0.0572,0.5315-0.2382,0.6707-0.4943
				c0.0184-0.0334,0.0272-0.0532,0.0306-0.061l0.0015-0.0008v-0.0025l0.002-0.0027c0.0052-0.01,0.0136-0.0275,0.0257-0.0541
				c0.0572-0.1327,0.087-0.2755,0.0876-0.42c0.0003-0.0779-0.009-0.1555-0.0277-0.2311
				C76.1557,88.861,76.1383,88.8091,76.1176,88.7585z M75.6582,89.3672l-0.0016,0.0024v0.0026l-0.014,0.0287l-0.0029,0.0083
				l-0.0151,0.03c-0.0656,0.1289-0.1847,0.2223-0.3255,0.2554c-0.4062,0.0661-1.0049,0.1375-1.1842,0.1564
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.0063,0.0023-2.0111-0.0759-3.0049-0.2338l-0.0124-0.0033h-0.0157
				c-0.0467-0.0015-0.093-0.0091-0.1377-0.0225c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3995,0.2253-0.5295
				c0.6504-1.5679,1.5031-3.044,2.5365-4.3907c0.0419-0.0567,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.0319-0.04,0.044-0.0526l0.01-0.011c0.0286-0.026,0.0599-0.049,0.0932-0.0687
				c0.209-0.1202,0.4719-0.0902,0.6485,0.0739c0.015,0.0146,0.096,0.1142,0.1721,0.2106c0.0818,0.103,0.1681,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4846,4.2507c0.0413,0.0982,0.1152,0.2795,0.1806,0.4419
				c0.0326,0.0817,0.0631,0.1593,0.0846,0.2187c0.0113,0.0291,0.02,0.0548,0.027,0.0719l0.0065,0.0208v0.0018
				c0.0089,0.0383,0.0136,0.0774,0.014,0.1167c-0.0005,0.0765-0.0166,0.152-0.0473,0.2221L75.6582,89.3672z"/>
			<path fill="#231F20" d="M75.6919,89.0268l-0.0065-0.0208c-0.0071-0.0171-0.0157-0.0428-0.027-0.0719
				c-0.0215-0.0594-0.052-0.137-0.0846-0.2187c-0.0654-0.1624-0.1393-0.3437-0.1806-0.4419
				c-0.6452-1.5162-1.4801-2.9445-2.4846-4.2507c-0.0461-0.0583-0.1324-0.1693-0.2142-0.2723
				c-0.0761-0.0964-0.1571-0.196-0.1721-0.2106c-0.1766-0.1641-0.4395-0.1941-0.6485-0.0739
				c-0.0333,0.0197-0.0646,0.0427-0.0932,0.0687l-0.01,0.011c-0.0121,0.0121-0.0247,0.03-0.044,0.0526
				c-0.0335,0.042-0.0781,0.0978-0.123,0.1555c-0.0918,0.1171-0.1892,0.2426-0.2311,0.2993
				c-1.0334,1.3467-1.8861,2.8228-2.5365,4.3907c-0.0541,0.13-0.2064,0.4857-0.2253,0.5295v0.0009
				c-0.024,0.0614-0.0361,0.1269-0.0358,0.1928c0.0004,0.2403,0.1569,0.4526,0.3863,0.5241c0.0447,0.0134,0.091,0.021,0.1377,0.0225
				h0.0157l0.0124,0.0033c0.9938,0.1579,1.9986,0.2361,3.0049,0.2338c0.6623,0.0005,1.3243-0.0329,1.9832-0.1
				c0.1793-0.0189,0.778-0.09,1.1842-0.1564c0.1408-0.0331,0.2599-0.1265,0.3255-0.2554l0.0151-0.03l0.0029-0.0083l0.014-0.0287
				v-0.0026l0.0016-0.0024c0.0307-0.07,0.0469-0.1455,0.0475-0.2219c-0.0004-0.0393-0.0051-0.0784-0.014-0.1167L75.6919,89.0268z"/>
			<polygon fill="#FFFFFF" points="74.1266,86.6967 72.7316,86.6967 72.7316,85.2797 71.5746,85.2797 71.5746,86.6967
				70.1576,86.6967 70.1576,87.8537 71.5746,87.8537 71.5746,89.2487 72.7316,89.2487 72.7316,87.8537 74.1266,87.8537 			"/>
		</g>
	</g>
	<g id="A-04_1_">
		<g>
			<path fill="#231F20" d="M71.1506,128.3177h0.9v0.3525h-0.9V128.3177z"/>
			<path fill="#231F20" d="M73.1384,126.757c0.2434,0.007,0.4635,0.1467,0.5735,0.3639c0.3024,0.5826,0.3024,1.2759,0,1.8585
				c-0.1684,0.3261-0.5693,0.454-0.8954,0.2856c-0.1201-0.062-0.2184-0.1591-0.2819-0.2784
				c-0.2986-0.588-0.2958-1.2838,0.0075-1.8693C72.6605,126.8976,72.8889,126.7596,73.1384,126.757z M73.1419,127.1001h-0.0182
				c-0.1521,0.0093-0.283,0.1108-0.33,0.2558c-0.0907,0.2193-0.1323,0.4559-0.1221,0.693c-0.0108,0.2401,0.03,0.4797,0.1195,0.7027
				c0.0474,0.1821,0.2335,0.2913,0.4156,0.2438c0.1194-0.0311,0.2127-0.1244,0.2438-0.2438
				c0.0901-0.2191,0.1314-0.4553,0.1211-0.692c0.0097-0.2386-0.03-0.4766-0.1165-0.6992
				C73.3775,127.187,73.2731,127.1003,73.1419,127.1001z"/>
			<path fill="#231F20" d="M75.4581,127.9441v0.3873h0.3727v0.3619h-0.3727v0.6133h-0.3587v-0.6133H74.067l0.968-1.9288h0.4052
				l-0.789,1.5669h0.4482v-0.3873L75.4581,127.9441z"/>
		</g>
		<path fill="#231F20" d="M70.1889,128.7636h-1.56l-0.2383,0.5372h-0.3671l1.1289-2.5349h0.487l1.1517,2.5349h-0.3635
			L70.1889,128.7636z M70.086,128.5236l-0.6817-1.5472l-0.6751,1.5472H70.086z"/>
	</g>
</g>
<g id="CrownAndArrows_A-04">
  <g id="Arrows_A-04">
    <v-touch tag="g"
             id="Arrow_clockwise_A-04"
             class="arrow"
             v-on:tap="$emit('arrowClockwiseTap', arrowC)"
             v-on:press="$emit('arrowClockwisePress', arrowC)"
             v-bind:press-options="{threshold: 200}">
      <path fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M137.6404,94.8417
        c-0.5838,0.3434-1.2641,0.5403-1.9904,0.5403c-2.1716,0-3.932-1.7604-3.932-3.932c0-2.1716,1.7604-3.932,3.932-3.932
        c2.1716,0,3.932,1.7604,3.932,3.932"/>
      <polyline fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="140.1244,89.3858 139.582,91.45
        138.0707,89.9533"/>
    </v-touch>
    <v-touch tag="g"
             id="Arrow_counterclockwise_A-04"
             class="arrow"
             v-on:tap="$emit('arrowCounterClockwiseTap', arrowCC)"
             v-on:press="$emit('arrowCounterClockwisePress', arrowCC)">
      <path fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M133.6596,132.3417
        c0.5838,0.3434,1.2641,0.5403,1.9904,0.5403c2.1716,0,3.932-1.7604,3.932-3.932c0-2.1716-1.7604-3.932-3.932-3.932
        c-2.1716,0-3.932,1.7604-3.932,3.932"/>
      <polyline fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="131.1756,126.8858 131.718,128.95
        133.2293,127.4533"/>
    </v-touch>
  </g>
  <v-touch tag="g" id="Crown_A-04" class="crown" v-on:tap="$emit('crownTap', crown)">
    <linearGradient id="SVGID_A-04_15_" gradientUnits="userSpaceOnUse" x1="142.6911" y1="501.465" x2="135.4839" y2="488.9819" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
      <stop  offset="0" style="stop-color:#E6E7E7"/>
      <stop  offset="1" style="stop-color:#929497"/>
    </linearGradient>
    <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M139.0863,118.3417c0,0,1.4551-2.1062,1.4551-8.3206s-1.4551-8.3237-1.4551-8.3237"/>
    <linearGradient id="SVGID_A-04_16_" gradientUnits="userSpaceOnUse" x1="140.2831" y1="504.0014" x2="130.0612" y2="486.2968" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
      <stop  offset="0" style="stop-color:#E6E7E7"/>
      <stop  offset="1" style="stop-color:#929497"/>
    </linearGradient>
    <polygon fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" points="138.9246,119.3547
      139.0866,118.9567 139.0866,101.0567 138.9246,100.6617 138.3126,100.0857 131.8046,100.0857 131.1946,101.6977 131.1866,118.3417
      131.8246,119.9287 138.3226,119.9287 	"/>
    <linearGradient id="SVGID_A-04_17_" gradientUnits="userSpaceOnUse" x1="140.165" y1="486.3874" x2="129.9627" y2="504.0584" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
      <stop  offset="0" style="stop-color:#E6E7E7"/>
      <stop  offset="1" style="stop-color:#929497"/>
    </linearGradient>
    <polygon fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" points="131.8136,101.6977
      131.1946,101.6977 131.8046,100.1087 138.3046,100.1087 138.9136,101.6977 138.3126,101.6977 138.9256,103.0507
      138.3256,103.5177 138.9346,105.0277 138.3256,105.8857 138.9066,107.4407 138.3256,108.6267 138.9346,109.9947
      138.3256,111.4117 138.9416,112.5967 138.3026,114.1507 138.9116,115.0097 138.3026,116.5227 138.9216,116.9877
      138.3156,118.3417 138.9316,118.3417 138.3226,119.9287 131.8246,119.9287 131.2146,118.3417 131.8156,118.3417
      131.1996,116.9877 131.8026,116.5227 131.1936,115.0097 131.8026,114.1507 131.2226,112.5967 131.8026,111.4117
      131.2246,109.9947 131.8166,108.6267 131.1866,107.4407 131.8246,105.8857 131.2146,105.0277 131.8246,103.5177
      131.2076,103.0507"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8133" y1="101.6974" x2="138.3122" y2="101.6974"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8244" y1="103.5177" x2="138.3252" y2="103.5177"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8244" y1="105.8856" x2="138.3252" y2="105.8856"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8166" y1="108.6266" x2="138.3252" y2="108.6266"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8029" y1="111.4118" x2="138.3252" y2="111.4118"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8029" y1="114.1508" x2="138.3031" y2="114.1508"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8029" y1="116.5226" x2="138.3031" y2="116.5226"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8159" y1="118.3417" x2="138.3161" y2="118.3417"/>
  </v-touch>
</g>
<g id="Hands_A-04">
	<g id="Hour_A-04">
    <path fill="#332D2F" d="M69.2639,111.948c-1.0946-1.5168-0.7524-3.6337,0.7644-4.7283c0.5757-0.4155,1.2675-0.6396,1.9775-0.6405
      c1.8702-0.0018,3.3877,1.5129,3.3894,3.383c0.0018,1.8702-1.5129,3.3877-3.383,3.3894
      C70.9238,113.3527,69.9011,112.8304,69.2639,111.948z M73.5167,108.878c-0.6003-0.8329-1.7623-1.0215-2.5952-0.4212
      c-0.833,0.6004-1.0215,1.7623-0.4212,2.5952c0.6003,0.8329,1.7623,1.0215,2.5952,0.4212
      c0.4854-0.3498,0.7727-0.9119,0.7721-1.5101C73.8687,109.5733,73.7458,109.1934,73.5167,108.878z"/>
    <path fill="#595A5C" d="M74.7672,107.9743l-0.0254,0.0184c1.0897,1.5088,0.7499,3.6154-0.7589,4.7051
      c-0.5734,0.4141-1.2627,0.6373-1.97,0.638c-1.0831-0.0005-2.1003-0.5198-2.7358-1.3968
      c-1.0896-1.5089-0.7498-3.6154,0.7591-4.7051c0.5734-0.4141,1.2625-0.6373,1.9698-0.6379
      c1.083,0.0006,2.1003,0.5199,2.736,1.3969l0.0255-0.0184 M70.4896,111.0631c0.6059,0.8392,1.7775,1.0284,2.6168,0.4225
      c0.4886-0.3528,0.7778-0.919,0.7772-1.5217c0.0006-0.3935-0.1235-0.777-0.3546-1.0954c-0.606-0.8393-1.7777-1.0284-2.6169-0.4223
      c-0.4886,0.3528-0.7777,0.9191-0.7771,1.5218C70.1345,110.3613,70.2587,110.7448,70.4896,111.0631 M74.7672,107.9743
      c-1.0996-1.5234-3.2259-1.8668-4.7493-0.7672c-1.5234,1.0996-1.8668,3.2259-0.7672,4.7493
      c1.0996,1.5234,3.2259,1.8668,4.7493,0.7672c0.8868-0.6402,1.4117-1.6676,1.4107-2.7614
      C75.4105,109.2485,75.1853,108.5529,74.7672,107.9743z M70.5152,111.0446c-0.5958-0.8252-0.4097-1.9771,0.4154-2.5728
      c0.8251-0.5957,1.9771-0.4097,2.5728,0.4154c0.5958,0.8252,0.4097,1.9771-0.4154,2.5728
      c-0.3134,0.2263-0.69,0.3483-1.0766,0.3487C71.4185,111.8107,70.8613,111.526,70.5152,111.0446z"/>
    <polygon fill="#FFFFFF" points="69.1714,99.7618 71.9807,84.0232 74.8257,99.7559 73.4977,106.6799 70.5144,106.6828 			"/>
    <path fill="#332D2F" d="M71.9841,86.4282l2.4089,13.325l-1.2472,6.5022l-2.2812,0.0027l-1.2605-6.4996l2.3802-13.3301
       M71.9792,81.6197l-3.2405,18.1455l1.4247,7.3447l3.685-0.0042l1.4095-7.3478l-3.2791-18.1384L71.9792,81.6197z"/>
    <rect x="70.1638" y="102.8784" transform="matrix(1 -0.0011 0.0011 1 -0.112 0.0768)" fill="#332D2F" width="3.685" height="4.5378"/>
	</g>
	<g id="Minute_A-04">
    <path fill="#332D2F" d="M74.64,110.9537c-0.5368,1.462-2.1571,2.212-3.6192,1.6752c-1.462-0.5368-2.212-2.1571-1.6752-3.6192
      c0.4078-1.1106,1.4654-1.8486,2.6484-1.848c1.5577,0.0011,2.8196,1.2647,2.8185,2.8224
      C74.8124,110.3149,74.754,110.6432,74.64,110.9537z M70.6482,109.4865c-0.2729,0.7429,0.1081,1.5665,0.8511,1.8393
      c0.7429,0.2729,1.5664-0.1081,1.8393-0.8511l0,0c0.2752-0.7421-0.1033-1.5668-0.8453-1.842
      c-0.7421-0.2752-1.5667,0.1032-1.842,0.8453C70.6503,109.4808,70.6493,109.4836,70.6482,109.4865z"/>
    <path fill="#595A5C" d="M69.3326,109.0017l0.0295,0.0108c0.5337-1.4538,2.1449-2.1998,3.5988-1.6661
      c1.4538,0.5337,2.1998,2.1449,1.6661,3.5988c-0.5337,1.4538-2.145,2.1998-3.5988,1.6661
      c-1.1037-0.4051-1.8374-1.4558-1.8378-2.6314c0.0001-0.3301,0.0582-0.6576,0.1718-0.9674L69.3326,109.0017 M73.3537,110.4807
      c0.2766-0.7511-0.1081-1.5842-0.8592-1.8607c-0.7511-0.2766-1.5841,0.1081-1.8607,0.8592
      c-0.2766,0.7511,0.1081,1.5842,0.8592,1.8607c0.1602,0.059,0.3296,0.0892,0.5003,0.0892
      C72.6013,111.4308,73.1451,111.0517,73.3537,110.4807 M69.3325,109.0019c-0.5405,1.4694,0.2125,3.0989,1.6819,3.6394
      c1.4694,0.5405,3.0989-0.2125,3.6395-1.682s-0.2125-3.0989-1.6819-3.6394c-0.3132-0.1152-0.6443-0.1742-0.978-0.1743
      C70.8048,107.1431,69.741,107.885,69.3325,109.0019z M73.3241,110.4697c-0.2698,0.7354-1.0848,1.1127-1.8201,0.8428
      c-0.7354-0.2698-1.1127-1.0847-0.8428-1.8201c0.2698-0.7354,1.0847-1.1127,1.8201-0.8428
      c0.5584,0.2049,0.9295,0.7364,0.9297,1.3312C73.411,110.1477,73.3816,110.3132,73.3241,110.4697z"/>
    <polygon fill="#FFFFFF" points="70.9432,107.1008 69.1655,95.2331 71.9996,71.1089 74.8258,95.2334 73.0455,107.1011 			"/>
    <path fill="#332D2F" d="M71.9992,74.7577l2.3987,20.4687l-1.7186,11.4486l-1.3699,0l-1.7153-11.4492l2.4053-20.4685
       M72.0006,67.4605l-3.2648,27.779l1.8406,12.286l2.8345,0l1.8442-12.2851L72,67.4607L72.0006,67.4605z"/>
		<polygon fill="#332D2F" points="74.1306,98.9256 73.4116,103.455 73.4114,107.9859 70.5764,107.9845 70.5772,103.4549
			69.8813,98.9246 		"/>
	</g>
	<g id="Second_A-04">
    <path fill="#231F20" d="M73.8831,109.9996c-0.0003,1.0396-0.8433,1.8821-1.8829,1.8818
      c-1.0396-0.0003-1.8822-0.8433-1.8818-1.8829c0.0003-1.0388,0.8421-1.881,1.8808-1.8819
      C73.039,108.1174,73.8819,108.9598,73.8831,109.9996z"/>
    <line fill="none" x1="72.1148" y1="111.8827" x2="71.8871" y2="111.8827"/>
    <polygon fill="#231F20" points="71.7168,111.8826 72.2839,111.8819 72.8508,124.172 71.15,124.1719 			"/>
    <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="72" y1="111.8827" x2="72.0003" y2="67.48"/>
	</g>
</g>
</svg>
</template>

<script>
export default {
  name: 'a04',
  props: ['data'],
  computed: {
    model() {
      if (this.data.model) return this.data.model;
    },
    crown() {
      if (this.model) {
        return this.model.components.crown;
      }
    },
    cArrow() {
      if (this.crown) {
        return this.crown.arrowElements.find(ae => ae.id === 'Arrow_clockwise_A-04');
      }
    },
    ccArrow() {
      if (this.crown) {
        return this.crown.arrowElements.find(ae => ae.id === 'Arrow_counterclockwise_A-04');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .crown, .pusher, .arrow {
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
  }
</style>
